import React, { useState } from 'react'
import { useWordPressPage } from '../uses/useWordPressPage'
import WordPressPage from '../components/WordPressPage'

import Layout from '../components/Layout'
import MembersList from '../components/MembersList'

const path = require('path')

const SLUG = path.basename(__filename).split('.')[0]

export default () => {
  const page = useWordPressPage(SLUG)
  const [pointer, setPointer] = useState('none')
  return (
    <Layout slug={SLUG}>
      <WordPressPage page={page} />
      <div id="page-content" />
      <div className="page-content text-content">
        <div
          className="headlines"
          dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
        />
        <div
          className="event-media media-text"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
      </div>
      <MembersList />

      <section onClick={() => setPointer('auto')} className="map-container">
        <iframe
          src="https://www.google.com/maps/d/u/0/embed?mid=1t0u1biBBmTylAQhAZMywzv1DtSEkmct3"
          width="100%"
          height="480"
          frameBorder="0"
          style={{ pointerEvents: pointer }}
        />
      </section>
      <a
        href="https://www.google.com/maps/d/u/0/viewer?mid=1t0u1biBBmTylAQhAZMywzv1DtSEkmct3&ll=46.589131865321555%2C6.699381047082966&z=12"
        target="_blank"
        className="members-map"
      >
        Carte des membres
      </a>
    </Layout>
  )
}
